import { render, staticRenderFns } from "./DocumentMappingModal.vue?vue&type=template&id=7c032a0c&scoped=true"
import script from "./DocumentMappingModal.vue?vue&type=script&lang=js"
export * from "./DocumentMappingModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentMappingModal.vue?vue&type=style&index=0&id=7c032a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c032a0c",
  null
  
)

export default component.exports